<mat-form-field >
    <mat-label>Select a file</mat-label>
    <mat-select [(ngModel)]="selectedFile" name="diffFile">
        <mat-option *ngFor="let file of availableFiles" [value]="file">
            {{file.name}}
        </mat-option>
    </mat-select>
</mat-form-field>
